import { useEffect, useRef } from "react";

const Recognition = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);
export const wakeSupported = !!Recognition;
const WAKE_RE = /\b(jarvis|jervis|travis)\b[\s,.!?]*(.*)$/i;

export function useWakeWord(enabled, onWake) {
  const cb = useRef(onWake);
  cb.current = onWake;
  useEffect(() => {
    if (!enabled || !Recognition) return;
    let alive = true;
    let rec = null;
    const begin = () => {
      if (!alive) return;
      rec = new Recognition();
      rec.continuous = true;
      rec.interimResults = false;
      rec.lang = navigator.language || "en-US";
      rec.onresult = (e) => {
        const text = e.results[e.results.length - 1][0].transcript.trim();
        const m = text.match(WAKE_RE);
        if (!m) return;
        alive = false;
        rec.abort();
        cb.current(m[2].trim());
      };
      rec.onend = () => alive && setTimeout(begin, 300);
      rec.onerror = (e) => { if (e.error === "not-allowed" || e.error === "service-not-allowed") { alive = false; cb.current(null, e.error); } };
      try { rec.start(); } catch { /* already started */ }
    };
    begin();
    return () => { alive = false; rec?.abort(); };
  }, [enabled]);
}
